export default "__VITE_ASSET__BMLblYaJ__"